export default __webpack_public_path__ + "static/media/kerumunan.5f16db2c.png";